// © Microsoft Corporation. All rights reserved.

import { ComponentConnector, FollowInfo, UsersConnector } from "../../Social.props";

import FollowButton from "../../follow-button/FollowButton";
import Popover from "../../common/popover/Popover";
import { PopoverProps } from "../../common/popover/Popover";
import React from "react";
import { SocialClassNameContract } from "../../Social.classnames";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";
import { SocialState } from "../../Social.state";
import { TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { User } from "@msnews/social-data-service";
import avatarFallback from "../../utils/avatarFallback";
import { connect } from "react-redux";
import openProfilePage from "../../utils/openProfilePage";
import { placeholderImages } from "../../utils/images";

export interface UserCardProps extends PopoverProps {
    componentConnector: ComponentConnector;
    usersConnector: UsersConnector;
    me: User;
    users: { [id: string]: FollowInfo;}; // dictionary definening
    id: string;
    t: SocialLocalizedStrings;
    managedClasses?: SocialClassNameContract;
    market: string;
    theme: string;
    mainTelemetryObject: TelemetryObjectBase;
}

interface UserCardState {
    hasMouseEnter: boolean
}

const mapStateToProps = function(state: SocialState) {
    return {
        theme: state.theme
    };
};

export class UserCard extends React.Component<UserCardProps, UserCardState> {
    containerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.containerRef = React.createRef();

        this.state = {
            hasMouseEnter: false
        };
    }

    componentDidMount() {
        const fetchUser = this.props.usersConnector.fetchUser;
        const fetchIsUserFollowed = this.props.usersConnector.fetchIsUserFollowed;
        if (!fetchUser || !fetchIsUserFollowed) { return console.warn("Missing props 'usersConnector.fetchUser' or 'userConnector.fetchIsUserFollowed'"); }
        fetchUser(this.props.id)
            .then(_ => {
                fetchIsUserFollowed(this.props.id);
            });
    }

    mouseEnterHandler() {
        this.setState({hasMouseEnter: true});
    }

    render() {
        const {componentConnector, me, t, managedClasses, id, usersConnector, users, market, theme, mainTelemetryObject} = this.props;
        const user = this.props.users && this.props.users[id] ? this.props.users[id].data : undefined;
        if (!user || !users) { return null; }

        const {id: userId, name, postsCount, isFollowing, followersCount, likesCount, isBanned} = user || {};
        const avatarUrl = (user && user.avatarUrl ? user.avatarUrl : null) || placeholderImages.avatar;
        const isSelf = me.id == userId;

        const triggerRef = this.state.hasMouseEnter ? this.containerRef : this.props.triggerRef;
        return (
            <Popover {...{...this.props, triggerRef: triggerRef, hideOnMobile: true, className: managedClasses.userCardPopover, hasFocusLock: !this.props.isHover, isHover: this.props.isHover, hoverDelay: 600}}  >
                <div className={managedClasses.userCardContainer} ref={this.containerRef} onMouseOver={this.mouseEnterHandler.bind(this)}>
                    <a
                        {...openProfilePage(componentConnector, theme, id, market, "_blank")}
                    >
                        <img alt={t.AriaLabelsProfilePicture} className="cwt-avatar" src={avatarUrl} onError={(e)=>{ avatarFallback(e); }}/>
                    </a>
                    <div className="cwt-user-info">
                        <div className="cwt-user-header">
                            <div className="cwt-name-title">
                                <a
                                    className="cwt-name cwt-link"
                                    {...openProfilePage(componentConnector, theme, id, market, "_blank")}
                                >{name}</a>
                            </div>

                            {!isSelf && !isBanned &&
                <FollowButton {...{userId, managedClasses, usersConnector, t, mainTelemetryObject}} />
                            }
                        </div>
                        <div className="cwt-user-stats">
                            <div className="cwt-stat">
                                <h6>{t.UserCardPosts}</h6>
                                <span className="cwt-stat-counter">{postsCount || "-"}</span>
                            </div>
                            <div className="cwt-stat">
                                <h6>{t.UserCardLikes}</h6>
                                <span className="cwt-stat-counter">{likesCount || "-"}</span>
                            </div>
                            <div className="cwt-stat">
                                <h6>{t.ProfileFollowersLbl}</h6>
                                <span className="cwt-stat-counter">{followersCount || "-"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Popover>
        );
    }
}
export default connect(mapStateToProps)(UserCard);